import "./Healthcare.css";
import { useState, useEffect } from "react";
const Healthcare = () => {
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <div className="card-container">
      <div className="card">
        <div className="card-inner">
          <div className="card-front">
            <p>
              {rtl
                ? `سيكون إنشاء نظام حديث للرعاية
الصحية والشبكة الطبية والخدمات
الاجتماعية واحدا من

مكة والمدينة القابضة النجاحات
الأكثر مذهلة.

في البداية ، سيكون التركيز أكثر
على إنشاء البنية التحتية اللازمة
للمستشفيات ،

العيادات والصيدليات والمختبرات
ومرافق البحوث.`
                : fr
                ? `La mise en place d'un système
                moderne de soins de santé,
                d'un réseau médical et de
                services sociaux sera l'une des
                réussites les plus marquantes
                de MMH. Au début, l'accent
                sera mis sur l'établissement
                de l'infrastructure nécessaire
                des hôpitaux, des cliniques,
                des pharmacies, des
                laboratoires et des
                installations de recherche.`
                : `The establishment of a modern health care, Medical
                            Network and social services system will be one of
                            MMH most stunning successes. In the beginning, the
                            emphasis will be more on establishing the necessary
                            infrastructure of hospitals, clinics, pharmacies,
                            laboratories and research facilities.`}
            </p>
          </div>
          <div className="card-back">
            <img
              className="-img"
              src={require("../../../Assets/images/Digital_infrastructure.jpg")}
              alt="Digital_infrastructure"
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-inner">
          <div className="card-front">
            <p>
              {rtl
                ? `ستقوم مكة والمدينة القابضة بإنشاء
معظم مرافق الرعاية الصحية في
جميع أنحاء البلدان الأفريقية وغيرها

البلدان. كما سيشجع مصرفنا
الاستثماري الإسلامي على زيادة
مشاركة القطاع الخاص من خلال
تقديم

قروض طويلة الأجل بدون فوائد
لإنشاء المستشفيات والعيادات
والصيدليات.`
                : fr
                ? `MMH mettra en place la
                plupart des installations de
                soins de santé dans les pays
                africains et dans d'autres
                pays. Notre banque
                d'investissement islamique
                encouragera également une
                plus grande participation du
                secteur privé en proposant
                des prêts à long terme sans
                intérêt pour la création
                d'hôpitaux, de cliniques et de
                pharmacies.`
                : `MMH will establish most of the health care
                            facilities throughout the African countries and
                            other countries. Our Islamic investment bank will
                            also encourage greater private sector involvement by
                            offering long-term, interest-free loans for the
                            establishment of hospitals, clinics and pharmacies.`}
            </p>
          </div>
          <div className="card-back">
            <img
              className="-img"
              src={require("../../../Assets/images/largest-pharmaceutical-companies.jpg")}
              alt="largest-pharmaceutical-companies"
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-inner">
          <div className="card-front">
            <p>
              {rtl
                ? `جانب آخر من شبكة الخدمات
الاجتماعية لمكة والمدينة القابضة
هو توفير السكن للبلد سريع النمو ،

الخدمات الصحية والاجتماعية،
وإنشاء شبكة طبية حديثة، والرعاية
الجيدة في متناول الجميع،

شبكة الرعاية الصحية ورعاية ذوي
الإحتياجات الخصوصية وبناء
المساكن.`
                : fr
                ? `Un autre aspect du réseau de
                services sociaux de MMH
                consiste à fournir des
                logements à la population du
                pays, qui connaît une
                croissance rapide, Santé et
                services sociaux, Mise en
                place d'un réseau médical
                moderne, Soins de qualité
                accessibles à tous, Réseau de
                soins de santé, Soins aux
                personnes handicapées et
                Construction de logements.`
                : `Another aspect of MMH social services network is
                            providing housing for the country’s fast-growing,
                            Health & Social Services, Establishing a Modern
                            Medical Network, Quality Care accessible to All,
                            Health Care Network, Care for the Disabled and
                            Housing Construction.`}
            </p>
          </div>
          <div className="card-back">
            <img
              className="-img"
              src={require("../../../Assets/images/hospital.jpg")}
              alt="hospital"
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-inner">
          <div className="card-front">
            <p>
              {rtl
                ? `ومن السياسات ذات الأهمية الخاصة
تقديم قروض سهلة الأجل بدون فوائد
لبناء المنازل.

للأفراد والشركات. كما سيتم
تشجيع شركاتنا القابضة على تصنيع
المستحضرات الصيدلانية.`
                : fr
                ? `Une politique
                particulièrement
                importante a consisté à
                accorder aux particuliers
                et aux entreprises des
                prêts sans intérêt et à
                court terme pour la
                construction de
                logements. Les sociétés de
                notre holding seront
                également encouragées à
                fabriquer des produits
                pharmaceutiques.`
                : `A particularly important policy has been to provide
                            interest-free, easy-term loans for home construction
                            to individuals and companies. Our Holding
                            companies will be also encouraged to manufacture
                            pharmaceuticals.`}
            </p>
          </div>
          <div className="card-back">
            <img
              className="-img"
              src={require("../../../Assets/images/pharmaceuticals-industry-hero-965x560-1.jpg")}
              alt="pharmaceuticals"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Healthcare;
